module.exports = __webpack_public_path__ + "img/208.d26891aa.jpg";